/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from 'react'
import { SubmitHandler, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { BsFillShareFill } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { updateDesign } from '../../services/design.ts'
import { getCurrentUser } from '../../store/actions/authActions.ts'
import { RootState, useAppDispatch } from '../../store/index.ts'
import { HeaderLogo } from '../HeaderLogo/HeaderLogo.tsx'
import { UserMenu } from '../UserMenu/UserMenu.tsx'
import { animated, useTransition } from 'react-spring'
import { useSelector } from 'react-redux'
import socialMedia from '../../assets/img/social-media.png'

export const Header = () => {
  const dispatch = useAppDispatch()
  const {
    user: { data: user },
  } = useSelector((state: RootState) => state.userReducer)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null) // Create a ref for open user menu button
  const [showDropdown, setShowDropdown] = useState(false)
  const [copied, setCopied] = useState(false)
  const transitions = useTransition(showDropdown, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 250 },
  })

  const {
    handleSubmit,
    reset,
    formState: { defaultValues },
  } = useFormContext<DesignFormFields>()

  const copylink = (username: string) => {
    setCopied(true)
    const link = `https://waslat.app/${username}`
    navigator.clipboard.writeText(link)
    setTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  //  Submit user profile and design
  const onSubmit: SubmitHandler<DesignFormFields> = async (data) => {
    setLoading(true)
    let isModified = false

    // Iterate over all fields and compare their values with default values
    for (const field in defaultValues) {
      if (data[field] !== defaultValues[field]) {
        isModified = true
        break
      }
    }

    // If no field has been modified, return without submitting the form
    if (!isModified) {
      console.log(
        'None of the fields have been changed from their default values. Form not submitted.',
      )
      return
    }

    const { avatar, color, themeId, fontId, ...rest } = data
    let imageUrl = ''

    if (avatar instanceof File) {
      const formData = new FormData()
      formData.append('file', avatar)
      // const response = await uploadUserAvatar(formData)
      await updateDesign(formData)
    }
    const designData = {
      ...rest,
      image: imageUrl,
      fontColor: color,
      theme_id: themeId,
      // font_id: fontId,
      font_id: 0, // TODO: only until fonts are in data base
    }

    const response = await updateDesign(designData)

    // Change avatar File type into string Url type
    if (response.status === 200) {
      toast.success(response.data.message)
      dispatch(getCurrentUser())
      reset({ ...data, avatar: imageUrl })
    }
    setLoading(false)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        buttonRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        !buttonRef?.current?.contains(event.target as Node)
      ) {
        closeMenu()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef, buttonRef])

  const closeMenu = () => {
    setShowDropdown(false)
  }

  return (
    <div className="flex items-center justify-between border-b border-gray-300 px-5 py-4">
      <HeaderLogo />
      <div className="flex gap-5">
        {/* <Button
          text={t('tryProFree')}
          type="button"
          className="px-2 text-sm text-white sm:w-40"
          onClick={() => navigate('/pricing')}
        /> */}
        <button
          type="submit"
          ref={buttonRef}
          className="flex h-[40px] cursor-pointer items-center justify-center gap-2 rounded-lg border border-blue-500 px-2 text-sm font-medium text-[#407BFF] shadow-md focus:outline-none sm:w-32"
          onClick={() => setShowDropdown((prevState) => !prevState)}
        >
          <BsFillShareFill color="#407BFF" />

          {t('Share')}
        </button>
        {transitions((styles: any, item: any) =>
          item ? (
            <animated.div
              style={styles}
              ref={dropdownRef}
              className=" absolute right-20 top-16 z-10 w-[320px] rounded-lg border border-gray-300 bg-white px-2.5 py-3 shadow-md"
            >
              <h5 className="text-md py-2 text-center font-bold">
                {t('shareTitle')}
              </h5>
              <p className="text-sm">{t('shareWaslat')}</p>
              <img src={socialMedia} alt="social media" className="w-full" />
              <div className="bottom-1 my-2 flex w-full cursor-pointer justify-between rounded-md p-3 shadow-md" onClick={() => copylink(user?.username)}>
                <span>https://waslat.app/{user?.username}</span>
                {copied ? <span className='text-blue-500'>{t('Copied')}</span> : <span>{t('Copy')}</span>}
              </div>
            </animated.div>
          ) : null,
        )}
        <UserMenu />
      </div>
    </div>
  )
}
